import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute,Params } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { DailyDeliveryPlan, DSPToken, Product,subProduct, DSPDayToken, DailyToken, DailyTokenItem, Plan, ProductsList, DailyDlvyPlanToken, ExcelAutoSelect, GenResponse } from '../../shared/misc-classes';
import { NotificationsService } from 'angular2-notifications';
import { ErrorPopupComponent } from '../../common/error-popup/error-popup.component';

@Component({
  selector: 'app-dlvy-plan',
  templateUrl: './dlvy-plan.component.html',
  styleUrls: ['./dlvy-plan.component.css']
})
export class DlvyPlanComponent implements OnInit {

  editToken:string = '';
  editHeader:string = '';
  editText:string = '';
  editType:string = '';
  editParam1:any;
  editParam2:any;
  
  editRow:DSPToken;
  currMonthDtObj:Date = new Date();
  datatables:DailyDeliveryPlan;
  dDSPDayTokenObj:DSPDayToken;
  type2Arr:Array<ProductsList>;
  
  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  failMessage:string = '';

  isExcelDataLoading:boolean = false;

  selView: number = 1;
  areChangesMade:boolean = false;

  planObj:Plan;
  btnName:string = '';
  mId:string = "41ae289e-4fb5-4f7e-7a0f-2dc974937c9c";
  hasmodaccess:boolean = false;
  daywiseItemList: Array<DailyToken>;
  excelStr:string;
  dlvryPlanExcelTokens:Array<DailyDlvyPlanToken>;

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild('uploadModal') public uploadModal:ModalDirective;  
  @ViewChild('fileUploadInput') public fileUploadInput: ElementRef;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;

  constructor(private _dataService:DataService,
              private _activatedRoute:ActivatedRoute, private _notify:NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Daily Delivery Plan Highlights";

    this._activatedRoute.queryParams.subscribe((params:Params) => {
      if(params['month']){
        this.currMonthDtObj = new Date(parseInt(params['month']));
      }
      this.loadMonthData();
      // this.loadPlan();
    });

  }
  // loadPlan(){
  //   this._dataService.loadPlan(this.currMonthDtObj, '').subscribe((_dailyProdHigh: Plan) => {
  //     if (_dailyProdHigh != null) {
  //       this.planObj = _dailyProdHigh;
  //     }
  //   });
  // }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  loadMonthData(){
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadDailyDeliveryPlan(this.currMonthDtObj).subscribe((_dailyDeliveryPlan:DailyDeliveryPlan) => {
        if(_dailyDeliveryPlan!=null){
          this.datatables = _dailyDeliveryPlan;
          // console.log(this.datatables)
          this.loadDateData();

          let _tmpDailyTokenList: Array<DailyToken> = [];
          for (var i = 0; i < this.datatables.dayTokens.length; i++) {
            let _tmpDate:Date = this.datatables.dayTokens[i].selDate;
            let _tmpDailyTokens:Array<DailyTokenItem> = [];
            
            let _indexer:number = 0;
            this.datatables.dayTokens[i].dateTokens.forEach((_tmpObj:DSPToken) => {
              _tmpDailyTokens.push(new DailyTokenItem( this.getDisplayTokenName(_tmpObj.customerName,_tmpObj.quantity), this.getIdObj(_tmpDate,_indexer),''));
              _indexer++;
            });
            _tmpDailyTokenList.push(new DailyToken(_tmpDate, _tmpDailyTokens));
          }
  
          this.daywiseItemList = _tmpDailyTokenList;
          this.isLoaded = true;
          this.isLoading = false;
          this.isFailed = false;
          // this.excelUploadModal();
        }
        else{
          this.daywiseItemList = null;
          this.isLoaded = false;
          this.isLoading = false;
          this.isFailed = true;
          this.failMessage = "Failed to get data from database, try again";
        }
    });
  }

  private getDisplayTokenName(_custId:string,_quantity:number){
    return this._dataService.getCustomerName(_custId) + ' ('+_quantity+')';
  }
  private getIdObj(_selDate:Date,_itemIndex:number){
    return {"selDate":_selDate,"rowIndex":_itemIndex}
  }

  getSubProduct(_id:string):string{
    if(_id){
      var _line = this._dataService.getProductLineBasedOnSubProduct(_id)
      return this._dataService.getSubProduct(_id);
    }
    else
    return ''
  }

  getProductName(_prodId: string): string {
    //console.log(_prodId)
    if (_prodId)
      return this._dataService.getProductName(_prodId);
    return '';
  }

  ItemSelected(_evntObj){
    this.selView = 1;
    this.currMonthDtObj.setDate(_evntObj.selDate.getDate());
    this.loadDateData();
  }

  public prevMonthSel():void{
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    // this.loadPlan();
  }
  nextMonthSel(){
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
    // this.loadPlan();
  }
  prevDateSel():void{
    if(this.currMonthDtObj.getDate() > 1){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()-1);
      this.loadDateData();
    }
  }
  nextDateSel():void{
    var _tmpLastDayOfMonth:Date = new Date(this.currMonthDtObj.getFullYear(),this.currMonthDtObj.getMonth()+1,0);
    if(this.currMonthDtObj.getDate() < _tmpLastDayOfMonth.getDate()){
      this.currMonthDtObj.setDate(this.currMonthDtObj.getDate()+1);
      this.loadDateData();
    }
  }

  loadDateData():void{
    let _tmpDPHDayToken:DSPDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    if(_tmpDPHDayToken == null){
      this.datatables.addDateToken(this.currMonthDtObj);  
      _tmpDPHDayToken = this.datatables.getDateToken(this.currMonthDtObj);
    }
    this.dDSPDayTokenObj = _tmpDPHDayToken;
  }

  public getSelYear(): number {
    return this.currMonthDtObj.getFullYear();
  }
  public getSelMonth(): number {
    return this.currMonthDtObj.getMonth() + 1;
  }
  public setView(_viewNo: number): void {
    this.selView = _viewNo;
  }

  public showChildModal(_editToken:string,_param1:any,_param2:any):void {
    switch(_editToken){
      case "rowedit":
      this.btnName = "Done";
        this.editRow = _param1.cloneSelf();
        
      this.typeChanged(this.editRow.type)
        this.editType = _editToken;
        this.editHeader = "Edit Daily Delivery Plan (" + this.formatHeaderDate(this.dDSPDayTokenObj.selDate) +")";
      break;
      case "rownew":
      this.btnName = "Done";
      var _dt = new Date();
        this.editRow = new DSPToken(null,null,null,null,null,null,0,0,null,null,null,null,new Date(_dt).getTime())
        this.editType = _editToken;
        this.editHeader = "Add Daily Delivery Plan (" + this.formatHeaderDate(this.dDSPDayTokenObj.selDate) +")";
      break;
      case "selplan":
      this.btnName = "Save";
        this.editText = this.planObj.description;
        this.editType = 'text';
        this.editHeader = "Edit Plan";
      break;
    }
    this.editParam1 = _param1;
    this.editParam2 = _param2;
    this.editToken = _editToken;
    this.childModal.show();
  }

  // savePlan(){
  //   this._dataService.savePlan(this.planObj, '')
  //   .subscribe((resp: GenResponse) => {
  //     if (resp.status == "FAIL") {
  //       if(resp.errorCode == DataService.staleDataCode){
  //         this.errorPopup.showErrorPopup("Stale Data",resp.details);
  //       }else{
  //         this._notify.error('Failure', resp.details, this._dataService.failureOptions);
  //       }
  //     }
  //     else {
  //       this._notify.success('Success', resp.details, this._dataService.successOptions);
  //       this.loadMonthData();
  //       this.loadPlan();
  //     }

  //   });
  // }

  public addNewProdRow(_newRowToken: string, _selDate: Date) {
    switch (_newRowToken) {
      case "rownew":
        //this.dProdHighObj.addDateToken(_selDate,new DPHToken(null, null, null, 1));

        this.showChildModal(_newRowToken,null,null);
        break;
    }
  }
  public removeRecord( _tokenIndex:number) {
    this.dDSPDayTokenObj.removeToken(_tokenIndex);    
    this.areChangesMade = true;
  }
  parseDate(dateString: string): Date {
    if (dateString) {
      return new Date(dateString);
    } else {
      return null;
    }
  }

  dataEdited() {
    switch (this.editToken) {
      case "rowedit":

        if (this.editRow._date) {
          this.editParam1.dateNum = this.editRow._date.getTime();
        }
        else {
          this.editParam1.dateNum = this.editRow.dateNum;
        }
        this.editParam1.type = this.editRow.type;
        this.editParam1.product = this.editRow.product;
        this.editParam1.customerName = this.editRow.customerName;
        this.editParam1.saleOrder = this.editRow.saleOrder;
        this.editParam1.lineItem = this.editRow.lineItem;
        this.editParam1.subProduct = this.editRow.subProduct;
        this.editParam1.quantity = this.editRow.quantity;
        this.editParam1.dispatchStatus = this.editRow.dispatchStatus;
        this.editParam1.disRemarks = this.editRow.disRemarks;
        this.editParam1.status = this.editRow.status;
        this.editParam1.remark = this.editRow.remark;
        this.editParam1.creationDate = this.editRow.creationDate;
        this.areChangesMade = true;
        break;
      case "rownew":
        this.datatables.addDateToken(new Date(this.currMonthDtObj),
          new DSPToken(this.editRow.type, this.editRow.product, this.editRow.customerName,
            this.editRow.saleOrder, this.editRow.lineItem, this.editRow.subProduct,
            this.editRow.quantity, this.editRow.dateNum, this.editRow.status, this.editRow.remark,
            this.editRow.dispatchStatus, this.editRow.disRemarks, this.editRow.creationDate));
        this.areChangesMade = true;
        break;
      // case "selplan":
      //   this.datatables.plan = this.editText;
      //   this.planObj.description = this.editText;
      //   this.planObj.monthDateNum = this.currMonthDtObj.getTime();
      //   // this.savePlan();
        // break;
    }
    this.hideChildModal();
  }

  formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }

  formatHeaderDate(_date:Date):string{
    if (_date) {
      return GenService.getDateFormatStr(_date, "DD-MMM");
    }
    return '-';
  }

  formatDate(_date:Date):string{
    if(_date){      
      return GenService.getDateFormatStr(_date, "DD-mmm-YYYY");
    }
    return '-';
  }
  getData(option){
     if(option){
       return option
     }
     return ''
  }
  getProductData(type2:string):string{
    if(type2){
      return this._dataService.getProductName(type2)
    }
    return ''
  }
  getCustomerName(_custId:string):string{
    if(_custId)
      return this._dataService.getCustomerName(_custId);
    return '';
  }
  getMainProduct(type:string):string{
    if(type){
      return this._dataService.getProductType(type);
    }
    return ''
  }
  // getResponsiblePrsn(_prsn:string):string{
  //   if(_prsn) return this._dataService.getResponsiblePrsn(_prsn);
  //   return ''
  // }
  getTypeReady(_id:string):string{
    if(_id) return this._dataService.getTypeReady(_id)
    return ''
  }
  // getTypeAvailable(_id:string):string{
  //   if(_id) return this._dataService.getTypeAvailable(_id)
  //   return ''
  // }
  getStatus(_id:string):string{
    if(_id == "forwarded"){
      return "Forwarded";
    }
    if(_id) return this._dataService.getDispStatus(_id)
    return ''
  }
  // getTypeStructure(_id:string):string{
  //   if(_id) return this._dataService.getTypeStructure(_id)
  //   return ''
  // }
  public hideChildModal():void {
    this.childModal.hide();
  }
  public cancelDataSave(): void {
    this.childModal.hide();
  }

  typeChanged(ty){
    this.editRow.type = ty;
    this.type2Arr = this._dataService.getProductList(ty);
  }
  
  
  saveData(_sendMail:boolean):void{
    if(this.validateData()==true){
      this._dataService.saveDailyDeliveryPlan(this.datatables,_sendMail)
      .subscribe((resp:GenResponse) => {
        if(resp.status=="FAIL"){
          //failed to save
          if(resp.errorCode == DataService.staleDataCode){
            this.errorPopup.showErrorPopup("Stale Data",resp.details)
          }else{
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
          // this.loadPlan();
        }

      });
    }
  }
  validateData():boolean{
    return true;
  }
  discardData():void{
    this.loadMonthData();
    // this.loadPlan();
  }

  excelUploadModal(){
    this.uploadModal.show();
  }

  
  // fileChange(event) {
  //   console.log('on file change called')
  //   //this.image = '/assets/loader.gif';//show progress
  //   let fileList: FileList = event.target.files;
  //   if (fileList.length > 0) {
  //     let file: File = fileList[0];
  //   }
  //   this.readThis(event.target)
  // }
  // readThis(inputValue: any): void {
  //   var file: File = inputValue.files[0];
  //   var myReader: FileReader = new FileReader();
  //   myReader.onloadend = (e) => {
  //     this.excelStr = myReader.result +'';
  //     this.getExcelExtract(file.name, file.type);
  //   }
  //   myReader.readAsDataURL(file);
  // }

  // getExcelExtract(_tempName, _tempType) {
  //   this.isExcelDataLoading = true;
  //   this._dataService.ExtractExcelData(this.excelStr).subscribe((_dlvyTokens:Array<DailyDlvyPlanToken>) => {
  //     this.dlvryPlanExcelTokens = _dlvyTokens;
  //     this.isExcelDataLoading = false;
  //   },
  //     (err) => {
  //       this.isExcelDataLoading = false;
  //       this._notify.error('Error', 'Try again.', this._dataService.failureOptions);
  //       this.fileUploadInput.nativeElement.value = "";
  //       this.dlvryPlanExcelTokens = null;
  //       //this._notify.error('Error', err, this._dataService.notifyCriticalErrorOptions);
        
  //     }
  //   );

  // }

  getSelStatusClass(_tmpSelStatus:ExcelAutoSelect){
    switch(_tmpSelStatus){
      case ExcelAutoSelect.Not_Matched:
        return "fa fa-exclamation-circle red-font";
      case ExcelAutoSelect.Partial_Match:
        return "fa fa-exclamation-circle yellow-font";
      case ExcelAutoSelect.Perfect_Match:
        return "fa fa-check-circle green-font";
      case ExcelAutoSelect.User_Selection:
        return "fa fa-pencil green-font";
    }
    return "fa";
  }
  removeExcelTokenRecord(_rmvIndex:number){
    this.dlvryPlanExcelTokens.splice(_rmvIndex,1);    
  }
  hideUploadModal(){
    this.uploadModal.hide();
  }
  cancelExcelDataSave(){
    this.fileUploadInput.nativeElement.value = "";
    this.dlvryPlanExcelTokens = null;
    this.uploadModal.hide();
  }
  excelDataSubmitted(){

    this.dlvryPlanExcelTokens.forEach((_tmpObj:DailyDlvyPlanToken) =>{
      
      this.datatables.addDateToken(new Date(this.currMonthDtObj),
                      new DSPToken(_tmpObj.typeId,_tmpObj.productId,_tmpObj.customerId,
                        _tmpObj.sale_order,_tmpObj.line_item,_tmpObj.subProductId,
                        _tmpObj.qtyNum,_tmpObj.dateNum,_tmpObj.prodStatusId,
                        _tmpObj.remarks,_tmpObj.dispatchStatusId,_tmpObj.d_remarks,
                        (new Date()).getTime()));
    });

    this.fileUploadInput.nativeElement.value = "";
    this.dlvryPlanExcelTokens = null;
    this.areChangesMade = true;
    this.uploadModal.hide();
  }
}
